import { render, staticRenderFns } from "./InboxChannels.vue?vue&type=template&id=45931022&"
import script from "./InboxChannels.vue?vue&type=script&lang=js&"
export * from "./InboxChannels.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports